import { Text } from '@rneui/base/dist/Text/Text';
import { withTheme } from '../config';
export { Text };
export default withTheme(Text, 'Text');
